import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";

/**
 * InfoBoard 4 Vektor
 */
class InfoBoard4 extends Component {
    initialValuesLoaded = false;

    handleInput = (name, event) => {
        let { value } = event.target;

        if (event.target.value == "") {
            this.setState({
                [name]: ""
            });
            return;
        }

        this.setState({
            [name]: isNaN(value) ? value : parseFloat(value)
        });
    };

    handleBlur = () => {
        let {
            paths,
            lift,
            length,
            laps,
            quantity
        } = this.state;

        const lastRenderedQuantity = quantity;

        paths = parseFloat(paths);
        lift = parseFloat(lift);
        length = parseFloat(length);
        laps = parseFloat(laps);

        if (!this.initialValuesLoaded) {
            const calculatedQuantity = ((((paths*lift) + length) * laps)/1000).toFixed(2);

            this.setState(
                {
                    calculatedQuantity
                },
                () => {
                    this.updateParent();
                }
            );
            return;
        }
        
        quantity = ((((paths*lift) + length) * laps)/1000).toFixed(2);
        const calculatedQuantity = quantity;

        this.setState(
            {
                quantity,
                calculatedQuantity,
                lastRenderedQuantity
            },
            () => {
                this.updateParent();
            }
        );
    };

    updateParent = () => {

        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const { lastRenderedQuantity, quantity } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (
                lastRenderedQuantity != quantity
            ) {
                onChange(
                    id,
                    "quantity",
                    quantity,
                    "infoboard"
                );
                onChange(id, "clear_dont_recalculate_flag");
            }
        }
    };

    getPopulatedData() {
        const { data, extendedData, globalSettings } = this.props;

        data

        if (extendedData.paths) {
            let paths = parseFloat(extendedData.paths);
            if (isNaN(paths)) {
                paths = 0;
            }
            data.paths = paths;
        } else {
            data.paths = 0;
        }

        if (extendedData.lift) {
            let lift = parseInt(extendedData.lift);
            if (isNaN(lift)) {
                lift = globalSettings.infoboard4LiftLength;
            }
            data.lift = lift;
        } else {
            data.lift = globalSettings.infoboard4LiftLength;
        }

        if (extendedData.length) {
            let length = parseInt(extendedData.length);
            if (isNaN(length)) {
                length = 0;
            }
            data.length = length;
        } else {
            data.length = 0;
        }

        if (extendedData.laps) {
            let laps = parseInt(extendedData.laps);
            if (isNaN(laps)) {
                laps = 0;
            }
            data.laps = laps;
        } else {
            data.laps = 0;
        }

        return data;
    }

    constructor(props) {
        super(props);
        this.state = this.getPopulatedData();
    }

    componentDidMount() {
        this.handleBlur();
    }

    render() {
        const { sortIndex, isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;
        InfoBoardHelper.sortIndex = sortIndex;

        const {
            paths,
            lift,
            length,
            laps,
            calculatedQuantity
        } = this.state;

        return <InfoBoard>
            <div className="row">
                <div className="col-9">
                   
                    <div className="row">
                        <div className="col-12 inputFieldsHolder">
                            <div className="form-group mr-1 limitSize">
                                <label>Antal banor</label>
                                {isEditable &&
                                    InfoBoardHelper.renderTextInput({
                                        name: "paths",
                                        onChange: event =>
                                            this.handleInput("paths", event),
                                        onBlur: () => this.handleBlur(),
                                        value: paths
                                    })}
                                {!isEditable && (
                                    <input
                                        className="form-control form-control-sm text-right"
                                        readOnly
                                        value={paths}
                                    />
                                )}
                            </div>
                            <div className="form-group mr-1 limitSize">
                                <label>Lyft i mm</label>
                                {isEditable &&
                                    InfoBoardHelper.renderTextInput({
                                        name: "lift",
                                        onChange: event =>
                                            this.handleInput("lift", event),
                                        onBlur: () => this.handleBlur(),
                                        value: lift
                                    })}
                                {!isEditable && (
                                    <input
                                        className="form-control form-control-sm text-right"
                                        readOnly
                                        value={lift}
                                    />
                                )}
                            </div>
                            <div className="form-group mr-1 limitSize">
                                <label>Längd i mm</label>
                                {isEditable &&
                                    InfoBoardHelper.renderTextInput({
                                        name: "length",
                                        onChange: event =>
                                            this.handleInput("length", event),
                                        onBlur: () => this.handleBlur(),
                                        value: length
                                    })}
                                {!isEditable && (
                                    <input
                                        className="form-control form-control-sm text-right"
                                        readOnly
                                        value={length}
                                    />
                                )}
                            </div>
                            <div className="form-group mr-1 limitSize">
                                <label>Pass</label>
                                {isEditable &&
                                    InfoBoardHelper.renderTextInput({
                                        name: "laps",
                                        onChange: event =>
                                            this.handleInput("laps", event),
                                        onBlur: () => this.handleBlur(),
                                        value: laps
                                    })}
                                {!isEditable && (
                                    <input
                                        className="form-control form-control-sm text-right"
                                        readOnly
                                        value={laps}
                                    />
                                )}
                            </div>
                            <div className="form-group mr-1">
                                <label>Summa lpm</label>
                                <input
                                    className="form-control form-control-sm form-control-hilite text-right"
                                    value={calculatedQuantity || 0}
                                    disabled
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={(showHelpTexts ? "col-3" : "d-none")}>
                    <div className="helperTextBlock">
                        <p><b>Infoboard - Vektorer</b><br />
                            Hjälptext kommer inom kort</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 inputFieldsHolder">
                    {InfoBoardHelper.renderHiddenInput({
                        name: "infoboardType",
                        value: 4
                    })}
                </div>
            </div>
        </InfoBoard>;
    }
}

export default InfoBoard4;
